import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import Autocomplete from '../../custom/autocomplete'
import LabelCustom from '../../label-custom'
import UseProvinces from '../../../hooks/use-adds-provinces'
import UseDistricts from '../../../hooks/use-adds-districts'
import UseSubdistricts from '../../../hooks/use-adds-subdistricts'
import { Controller } from 'react-hook-form'
import { getDistrictsAPI, getSubdistrictsAPI } from '../../../services/address'
import useNumberInput from '../../../helper/input-fix-num'

function CurrentAddress({
  data,
  control,
  setValue,
  getValues,
  errors,
  setError
}) {
  const [provincIdFirst, setProvincIdFirst] = useState(0)
  const [districtId, setDistrictId] = useState(0)
  const [cr_provincId, setCr_ProvincId] = useState(0)
  const [cr_districtId, setCr_DistrictId] = useState(0)

  const provinces = UseProvinces()
  const districts_first = UseDistricts(provincIdFirst)
  const subDistricts_first = UseSubdistricts(districtId)

  const cr_districts = UseDistricts(cr_provincId)
  const cr_subDistricts = UseSubdistricts(cr_districtId)

  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    if (data) {
      setValue('address', data.address)
      setError('address', data.address)

      setValue('address_first', data.address_first)
      setError('address_first', data.address_first)

      setValue('cr_post_code', data.post_code)
      setError('cr_post_code', data.post_code)

      setValue('post_code_first', data.post_code_first)
      setError('post_code_first', data.post_code_first)
    }
  }, [data, setError, setValue])

  useEffect(() => {
    if (data) {
      const provinceNew = provinces.find((d) => d.label === data.province)
      setCr_ProvincId(provinceNew.value)
      setValue('province', provinceNew)
      setError('province', provinceNew)

      const province_firstNew = provinces.find(
        (d) => d.label === data.province_first
      )
      setProvincIdFirst(province_firstNew.value)

      setValue('province_first', province_firstNew)
      setError('province_first', province_firstNew)
    }
  }, [data, provinces, setError, setValue])

  const [district, setDistrict] = useState({})
  useEffect(() => {
    const fnDistricts = async () => {
      const provinceNew = provinces.find((d) => d.label === data.province)
      const res = await getDistrictsAPI(provinceNew.value)
      if (!res) return

      if (res.result.length > 0) {
        const cr_districtsNew = res.result.find(
          (d) => d.AMPHUR_NAME === data.district
        )
        setValue('district', {
          value: cr_districtsNew?.AMPHUR_ID,
          label: cr_districtsNew?.AMPHUR_NAME
        })
        setDistrict({
          value: cr_districtsNew?.AMPHUR_ID,
          label: cr_districtsNew?.AMPHUR_NAME
        })
        setError('district', cr_districtsNew)

        setCr_DistrictId(cr_districtsNew?.AMPHUR_ID)
        fnSub_district(cr_districtsNew?.AMPHUR_ID)
      }
    }
    const fnDistricts_first = async () => {
      const province_firstNew = provinces.find(
        (d) => d.label === data.province_first
      )
      const res = await getDistrictsAPI(province_firstNew.value)
      if (!res) return

      if (res.result.length > 0) {
        const districtsNew = res.result.find(
          (d) => d.AMPHUR_NAME === data.district_first
        )
        setValue('district_first', {
          value: districtsNew?.AMPHUR_ID,
          label: districtsNew?.AMPHUR_NAME
        })
        setError('district_first', districtsNew)

        setDistrictId(districtsNew?.AMPHUR_ID)
        fnSub_district_first(districtsNew?.AMPHUR_ID)
      }
    }
    if (data && provinces.length > 0) {
      fnDistricts()
      fnDistricts_first()
    }
  }, [data, provinces, setError, setValue])

  const [sub_district, setSub_district] = useState({})
  const fnSub_district = async (d) => {
    if (d) {
      const res = await getSubdistrictsAPI(d)
      if (!res) return
      if (res.result.length > 0) {
        const cr_subDistrictsNew = res.result.find(
          (d) => d.DISTRICT_NAME === data.sub_district
        )
        setSub_district({
          value: cr_subDistrictsNew?.DISTRICT_ID,
          label: cr_subDistrictsNew?.DISTRICT_NAME
        })
        setValue('sub_district', {
          value: cr_subDistrictsNew?.DISTRICT_ID,
          label: cr_subDistrictsNew?.DISTRICT_NAME
        })
        setError('sub_district', cr_subDistrictsNew)
      }
    }
  }
  const fnSub_district_first = async (d) => {
    if (d) {
      const res = await getSubdistrictsAPI(d)
      if (!res) return
      if (res.result.length > 0) {
        const sub_district_firstNew = res.result.find(
          (d) => d.DISTRICT_NAME === data.sub_district_first
        )
        setValue('sub_district_first', {
          value: sub_district_firstNew?.DISTRICT_ID,
          label: sub_district_firstNew?.DISTRICT_NAME
        })
        setError('sub_district_first', sub_district_firstNew)
      }
    }
  }

  const checkCurrent = (chk) => {
    if (chk) {
      setValue('address', getValues('address_first'))
      setError('address', getValues('address_first'))

      setValue('cr_post_code', getValues('post_code_first'))

      setError('cr_post_code', getValues('post_code_first'))

      setValue('province', getValues('province_first'))
      setError('province', getValues('province_first'))

      setValue('sub_district', getValues('sub_district_first'))
      setError('sub_district', getValues('sub_district_first'))

      setValue('district', getValues('district_first'))
      setError('district', getValues('district_first'))
    } else {
      if (data) {
        setValue('address', data.address)
        setError('address', data.address)

        setValue('cr_post_code', data.post_code)
        setError('cr_post_code', data.post_code)

        const provinceNew = provinces.find((d) => d.label === data.province)
        setCr_ProvincId(provinceNew.value)
        setValue('province', provinceNew)
        setError('province', provinceNew)

        setValue('sub_district', sub_district)
        setError('sub_district', sub_district)

        setValue('district', district)
        setError('district', district)
      } else {
        setValue('address', '')
        setError('address', false)

        setValue('cr_post_code', '')
        setError('cr_post_code', false)

        setValue('province', null)
        setError('province', false)

        setValue('sub_district', null)
        setError('sub_district', false)

        setValue('district', null)
        setError('district', false)
      }
    }
  }

  return (
    <>
      <Col xl={6} className="">
        <Card border="0">
          <Card.Body>
            <h5 className="mb-3 fw-bold">ที่อยู่ตามทะเบียนบ้าน</h5>

            <Row style={{ rowGap: '15px' }}>
              <Col xl={12}>
                <LabelCustom text="ที่อยู่ตามทะเบียนบ้าน" />
                <Controller
                  name={'address_first'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Form.Control value={value} onChange={onChange} />
                  )}
                />
                {errors.address_first?.message && (
                  <label className="small text-danger">
                    {errors.address_first.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="จังหวัด" />
                <Controller
                  name={'province_first'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      maxLength={300}
                      value={value}
                      options={provinces}
                      onChange={(d) => {
                        setProvincIdFirst(d.value)
                        setValue('province_first', d)
                        setError('province_first', false)

                        setValue('district_first')
                        setValue('sub_district_first')
                        setValue('post_code_first', '')

                        setError('district_first', true)
                        setError('sub_district_first', true)
                        setError('post_code_first', true)
                      }}
                    />
                  )}
                />
                {errors.province_first?.message && (
                  <label className="small text-danger">
                    {errors.province_first.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="เขต / อำเภอ" />
                <Controller
                  name={'district_first'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      disabled={provincIdFirst > 0 ? false : true}
                      options={districts_first}
                      onChange={(d) => {
                        setDistrictId(d.value)
                        setValue('district_first', d)
                        setError('district_first', false)

                        setValue('sub_district_first')
                        setError('sub_district_first', true)
                        setValue('post_code_first', '')
                        setError('post_code_first', true)
                      }}
                    />
                  )}
                />
                {errors.district_first?.message && (
                  <label className="small text-danger">
                    {errors.district_first.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="แขวง / ตำบล " />
                <Controller
                  name={'sub_district_first'}
                  control={control}
                  render={({ field: { onChange, value = null } }) => (
                    <Autocomplete
                      value={value}
                      disabled={districtId > 0 ? false : true}
                      options={subDistricts_first}
                      onChange={(d) => {
                        setValue('post_code_first', d.code)

                        onChange(d)
                      }}
                    />
                  )}
                />
                {errors.sub_district_first?.message && (
                  <label className="small text-danger">
                    {errors.sub_district_first.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="รหัสไปรษณีย์" />
                <Controller
                  name={'post_code_first'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Form.Control
                      value={value}
                      onChange={onChange}
                      onKeyDown={handleKeyDownNum}
                    />
                  )}
                />
                {errors.post_code_first?.message && (
                  <label className="small text-danger">
                    {errors.post_code_first.message}
                  </label>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
      <Col xl={6} className="">
        <Card border="0">
          <Card.Body>
            <div className="mb-2 d-flex justify-content-between">
              <h5 className="fw-bold">ที่อยู่ปัจจุบัน</h5>
              <Form.Check
                type={'checkbox'}
                id={`default-checkbox`}
                label={`ตามที่อยู่ทะเบียนบ้าน`}
                onClick={(e) => {
                  checkCurrent(e.currentTarget.checked)
                }}
              />
            </div>

            <Row style={{ rowGap: '15px' }}>
              <Col xl={12}>
                <LabelCustom text="ที่อยู่ปัจจุบัน" />
                <Controller
                  name={'address'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Form.Control
                      maxLength={300}
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.address?.message && (
                  <label className="small text-danger">
                    {errors.address.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="จังหวัด" />
                <Controller
                  name={'province'}
                  control={control}
                  render={({ field: { onChange, value = null } }) => (
                    <Autocomplete
                      value={value}
                      options={provinces}
                      onChange={(d) => {
                        setCr_ProvincId(d.value)
                        onChange(d)

                        setValue('district')
                        setError('district', true)

                        setValue('cr_post_code', '')

                        setValue('sub_district')
                        setError('sub_district', true)
                      }}
                    />
                  )}
                />
                {errors.province?.message && (
                  <label className="small text-danger">
                    {errors.province.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="เขต / อำเภอ" />
                <Controller
                  name={'district'}
                  control={control}
                  render={({ field: { onChange, value = null } }) => (
                    <Autocomplete
                      value={value}
                      disabled={cr_provincId > 0 ? false : true}
                      options={cr_districts}
                      onChange={(d) => {
                        setCr_DistrictId(d.value)
                        onChange(d)

                        setValue('sub_district', null)
                        setValue('cr_post_code', '')
                      }}
                    />
                  )}
                />
                {errors.district?.message && (
                  <label className="small text-danger">
                    {errors.district.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="แขวง / ตำบล " />
                <Controller
                  name={'sub_district'}
                  control={control}
                  render={({ field: { onChange, value = null } }) => (
                    <Autocomplete
                      value={value}
                      disabled={cr_districtId > 0 ? false : true}
                      options={cr_subDistricts}
                      onChange={(d) => {
                        onChange(d)
                        setValue('cr_post_code', d.code)
                      }}
                    />
                  )}
                />
                {errors.sub_district?.message && (
                  <label className="small text-danger">
                    {errors.sub_district.message}
                  </label>
                )}
              </Col>
              <Col xl={6}>
                <LabelCustom text="รหัสไปรษณีย์" />
                <Controller
                  name={'cr_post_code'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Form.Control
                      value={value}
                      onChange={onChange}
                      // onKeyDown={handleKeyDownNum}
                    />
                  )}
                />
                {errors.cr_post_code?.message && (
                  <label className="small text-danger">
                    {errors.cr_post_code.message}
                  </label>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </>
  )
}

export default CurrentAddress
